import * as types from '../actions/actionTypes'

export default function branchReducer(state = [], action) {
  switch (action.type) {
    case types.LOAD_BRANCHES_SUCCESS:
      return action.branches
    default:
      return state
  }
}
